"use strict";
'app public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  props: ['error']
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["StartupError"]
window._app_exports.components.StartupError = exports.default ? exports.default : exports;
